<template>
  <main class="page-main service">
    <section class="page-heading-wrap">
      <html-view tag="h3" class="page-heading" :value="$t('service.head')" />
      <div class="app-download">
        <a
          href="https://apps.apple.com/kr/app/id378084485"
          target="_blank"
          class="btn btn-fill"
          data-ga="앱다운로드_IOS"
        >
          <i class="icon-ios" />
          iOS {{ $t('appDownload') }}
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.sampleapp"
          target="_blank"
          class="btn btn-fill"
          data-ga="앱다운로드_안드로이드"
        >
          <i class="icon-android" />
          Android {{ $t('appDownload') }}
        </a>
      </div>
    </section>

    <section class="page-visual" data-style="show">
      <video
        muted
        loop
        autoplay
        playsinline
        poster="~@/static/image/service/pc/dilly.png"
      >
        <source src="~@/static/video/dilly.mp4" type="video/mp4">
        Sorry, your browser doesn't support embedded videos.
      </video>
    </section>

    <navigation :tab-list="tabList" />

    <router-view />
  </main>
</template>

<script>
import gtag from '@/mixins/gtag'

import navigation from '@/components/base/Navigation'

export default {
  components: {
    navigation
  },
  mixins: [gtag],
  data () {
    return {
      tabList: [
        {
          pathname: 'service-order',
          title: 'menuService.deliveryTakeout'
        },
        {
          pathname: 'service-commerce',
          title: 'menuService.commerce'
        },
        {
          pathname: 'service-ceo',
          title: 'menuService.vendorsRiders'
        },
        {
          pathname: 'service-culture',
          title: 'menuService.culture'
        }
      ]
    }
  },
  mounted () {
    this.$nextTick(this.init)
  },
  methods: {
    init () {
      Array.from(document.querySelectorAll('[data-ga]')).forEach(element => {
        this.initGtag({
          element: element,
          // isView: true,
          ga: {
            name: '서비스_앱 다운로드',
            category: '서비스_앱 다운로드',
            label: element.dataset.ga,
            page: '서비스'
          }
        })
      })
    }
  }
}
</script>
